import { useTranslation } from 'react-i18next'
import { EHumanReviewRequestSubject } from './human-review-requests.type'

export const useSubjectLabels = (): Partial<Record<EHumanReviewRequestSubject, string>> => {
  const { t } = useTranslation()
  return {
    [EHumanReviewRequestSubject.ADMINISTRATIVE_DOCUMENTS]: t(
      'pages.dashboard.human-review-requests.tabs.administrative-documents',
    ),
    [EHumanReviewRequestSubject.MEDICAL_DOCUMENTS]: t(
      'pages.dashboard.human-review-requests.tabs.medical-documents',
    ),
    [EHumanReviewRequestSubject.CONVOCATION]: t('pages.dashboard.human-review-requests.tabs.convocation'),
    [EHumanReviewRequestSubject.POST_OP_CONTROL]: t(
      'pages.dashboard.human-review-requests.tabs.post-op-control',
    ),
  }
}
